// Version : 1.0.0
// Author : AGALYA
import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** NOMINEE DETAILS ADD START *********************** */
export const nomineeDetailsAdd = (verifyData: any) => {
	const data = {
		CreateNomineeDetailsToken: verifyData,
	};
	const url = `${API_URL}addNomineeDetails`;
	return makeApiCall(url, data);
};
/** ***************** NOMINEE DETAILS ADD END *********************** */
